import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "@/lib/api";

const SafeMeAuthContext = createContext(null);

export function SafeMeAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, object=user
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/safeme/auth/me");
      setUser(data.user);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/safeme/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/safeme/auth/register", payload);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.post("/safeme/auth/logout");
    } catch {
      /* ignore */
    }
    setUser(false);
  };

  return (
    <SafeMeAuthContext.Provider value={{ user, loading, login, register, logout, refresh }}>
      {children}
    </SafeMeAuthContext.Provider>
  );
}

export function useSafeMeAuth() {
  return useContext(SafeMeAuthContext);
}

export { formatApiError };
